var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFromDekstopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.32143 2C2.93958 2 2.5 2.35906 2.5 2.96875V8.80246L5.13836 5.27263C5.16702 5.23429 5.19839 5.19806 5.23223 5.16421C6.20855 4.1879 7.79146 4.1879 8.76777 5.16421C8.78854 5.18499 8.80839 5.20667 8.82726 5.22919L12.3982 9.49235L13.4822 8.41421L13.4834 8.41304C14.4598 7.4379 16.0418 7.43829 17.0178 8.41421C17.0418 8.43829 17.0647 8.46358 17.0862 8.48999L17.5 8.99833V2.96875C17.5 2.35906 17.0604 2 16.6786 2H3.32143ZM19.5 2.96875C19.5 1.40382 18.3086 0 16.6786 0H3.32143C1.69138 0 0.5 1.40382 0.5 2.96875V14C0.5 15.1046 1.39543 16 2.5 16H17.5C18.6046 16 19.5 15.1046 19.5 14V2.96875ZM17.5 12.1662L15.576 9.80285C15.3796 9.63357 15.0828 9.6421 14.8964 9.82843L14.8945 9.83034L13.0363 11.6785C12.8377 11.876 12.5655 11.9812 12.2857 11.9685C12.0059 11.9558 11.7443 11.8263 11.5645 11.6117L7.32991 6.55625C7.14673 6.39509 6.87383 6.39068 6.68575 6.54303L2.5 12.1431V13.0312C2.5 13.6409 2.93958 14 3.32143 14H16.6786C17.0604 14 17.5 13.6409 17.5 13.0312V12.1662Z",
    fill: "#52525B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.5C13.828 6.5 14.5 5.8295 14.5 5C14.5 4.172 13.828 3.5 13 3.5C12.172 3.5 11.5 4.172 11.5 5C11.5 5.8295 12.172 6.5 13 6.5Z",
    fill: "#52525B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFromDekstopIcon);
export default __webpack_public_path__ + "static/media/uploadFromDekstopIcon.a4dd174a6073f49f2ecf215cc38a7e14.svg";
export { ForwardRef as ReactComponent };